// extracted by mini-css-extract-plugin
module.exports = {"main":"NavContainer_main__3BnSU","navAndContent":"NavContainer_navAndContent__3RVOF","mainExpanded":"NavContainer_mainExpanded__W4Qv2"};